import { types } from "../types/types";

const initialState = {
  modalstatus:{
    show: false,
    withlink: false,
    linktype: "n",
    type: "",
    text: "",
    linkto: "",
    linktext: "",
    icontype: "",
  }
};

export const modalReducer = (state = initialState, action) => {
  switch (action.type) {
      case types.updateModalStatus:
        return {
          ...state,
          modalstatus: action.payload
        };

    default:
      return state;
  }
};
